var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "post-form-component",
      class: { "sharing-post": _vm.isSharingPost }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "POST_FORM." +
                  (_vm.isSharingPost
                    ? "SHARE_POST"
                    : _vm.post.isNew
                    ? "NEW_POST"
                    : "EDIT_POST")
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "post-text",
              class: { "with-text": !!_vm.post.description }
            },
            [
              _c("PowerArea", {
                attrs: {
                  id: "new-post-power-area",
                  maxlength: 25000,
                  placeholder: _vm.isSharingPost
                    ? "Add your comment here"
                    : "Add your post text here...",
                  value: {
                    text: _vm.post.description,
                    mentions: _vm.post.mentions
                  }
                },
                on: { paste: _vm.onPaste, change: _vm.changePost }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSharingPost
            ? _c(
                "vue-scroll",
                {
                  staticClass: "share-post-preview",
                  attrs: {
                    ops: {
                      scrollPanel: { maxHeight: 450 },
                      rail: { opacity: 0.3 },
                      bar: { keepShow: true }
                    }
                  }
                },
                [
                  _c("PostPreview", {
                    attrs: {
                      shareable: true,
                      post: _vm.post.share_post,
                      user: _vm.currentUser
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSharingPost
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "auto-embed-div-append`" },
                    [
                      _vm.textEmbed
                        ? _c("TextEmbed", {
                            attrs: {
                              embed_url_info: _vm.textEmbed,
                              with_delete_btn: true
                            },
                            on: { delete: _vm.deleteTextEmbed }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pasteLinkParsing
                        ? _c("div", { staticClass: "spinner-border" })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showAttachURL
                    ? _c("AttachURLModal", {
                        on: {
                          close: function($event) {
                            return _vm.toggleShowAttachURL(false)
                          },
                          addLink: _vm.addLink
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("ParsedLinks", {
                    attrs: { links: _vm.post.url_hash, editable: true },
                    on: { deleteLink: _vm.deleteLink }
                  }),
                  _vm._v(" "),
                  _c("EditAttachments", {
                    ref: "EditAttachments",
                    attrs: { post: _vm.post },
                    on: { delete: _vm.attachmentDelete }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.post.privacy === "friends_group"
        ? _c(
            "div",
            { staticClass: "modal-footer friends_group" },
            [
              _c("SelectListsOfFriends", {
                ref: "SelectListsOfFriends",
                attrs: { friends_group: _vm.post.group_ids },
                on: {
                  changed: function($event) {
                    _vm.post.group_ids = $event
                  }
                }
              }),
              _vm._v(" "),
              _c("AddFriendListBtn", {
                on: { created: _vm.friendsListCreated }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          !_vm.groupFeed
            ? _c("Privacy", {
                attrs: { privacy: _vm.post.privacy },
                on: {
                  change_privacy: function($event) {
                    _vm.post.privacy = $event
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-middle" },
            [
              !_vm.isSharingPost
                ? _c("AddCardCollectionBtn", {
                    attrs: { "show-search-card-view": _vm.showSearchCardView },
                    on: { chosen: _vm.addAttachment }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSharingPost
                ? _c("AddLinkBtn", {
                    attrs: {
                      url_hash: _vm.post.url_hash,
                      "show-add-link-view": _vm.showAddLinkView
                    },
                    on: {
                      changed: function($event) {
                        _vm.post.url_hash = $event
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("EmojiBtn", {
                attrs: { element_selector: "#new-post-power-area textarea" },
                on: {
                  add_emoji: function($event) {
                    _vm.post.description = $event
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-end" }, [
            _c(
              "a",
              {
                staticClass: "btn btn__round btn__bordered savePost",
                class: { disabled: _vm.submitFormDisabled },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.savePost($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("BUTTON." + (_vm.isSharingPost ? "SHARE" : "POST"))
                    ) +
                    "\n                "
                ),
                _vm.requestInProgress
                  ? _c("div", { staticClass: "spinner-border" })
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }